import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Input,
    Label,
    Row,
    TabContent,
    TabPane,
    Form,
    FormGroup,
    Option,
} from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';

const CarInquiry = () => {

    const API_URL = process.env.REACT_APP_APIURL;

    const breadcrumbItems = [
        { title: "Home", link: "/" },
        { title: "Car Inquiry", link: "#" },
    ];

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const[enquiry, updateInquiry] = useState(null);

    const fetchInquiry = async () => {
        try {
            setLoading(true);

            const response = await fetch(`${API_URL}/sellYourCar/enquiry`);
            console.log(response, "Sunny test");
            
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const data = await response.json();

            updateInquiry(data.data || []);

        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{
        fetchInquiry();
    },[])

    return (
        <>
            <div className="page-content">
                <Container fluid className="py-4">
                    <Breadcrumbs
                        title="Car Inquiry"
                        breadcrumbItems={breadcrumbItems}
                    />
                    <Card>
                        <CardBody>
                            <div className="table-responsive">
                                <table className="table table-centered align-middle table-nowrap mb-0 table-bordered">
                                    <thead className="table-light text-muted">
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Number</th>
                                            <th>Message</th>
                                            <th>Car</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="5" className="text-center">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="5" className="text-center text-danger">{error}</td>
                                            </tr>
                                        ) : enquiry.length > 0 ? (
                                            enquiry.map((el, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{el.name}</td>
                                                    <td>{el.email}</td>
                                                    <td>{el.number}</td>
                                                    <td>{el.message}</td>
                                                    <td>
                                                        <a href={el.car} target="_blank">{el.car}</a>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">No records found</td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </>
    )
}

export default CarInquiry;